import { botAddToGroupUrl } from '@otryad/shared';

import { Button } from '@/components/ui';
import { openTelegram } from '@/lib/links';
import { texts } from '@/lib/texts';
import { trpc } from '@/lib/trpc';

const t = texts.group;

/**
 * Как появляется группа отряда (раунд 4, C1). Капитану — кнопка «Добавить бота в группу»
 * (`t.me/<bot>?startgroup=bind_<id>&admin=invite_users`, бот привязывает группу сам) и одна строка
 * про права: боту нужно только «Добавление участников», чтобы выгрузить ссылку-приглашение.
 * Участнику служебную команду не показываем — только «попроси капитана».
 */
export function GroupHelp({
  squadId,
  isCaptain,
  hasGroup,
  secondary = false,
}: {
  squadId: string;
  isCaptain: boolean;
  /** Группа привязана, но ссылки нет — бот не админ */
  hasGroup: boolean;
  /** На главном кнопка не спорит с «Идёшь?» — второстепенная */
  secondary?: boolean;
}) {
  const config = trpc.auth.config.useQuery(undefined, { staleTime: 600_000 });
  const bot = config.data?.botUsername ?? null;

  if (!isCaptain) {
    return <p className="text-muted text-sm">{hasGroup ? t.memberNoLink : t.memberNone}</p>;
  }
  if (hasGroup) return <p className="text-muted text-sm">{t.boundNoLink}</p>;
  if (!bot) return <p className="text-muted text-sm">{t.noBot}</p>;
  return (
    <div className="flex flex-col gap-3">
      <ol className="flex list-decimal flex-col gap-1.5 pl-5 text-sm">
        {t.steps.map((s) => (
          <li key={s}>{s}</li>
        ))}
      </ol>
      <Button
        fullWidth
        variant={secondary ? 'secondary' : 'primary'}
        onClick={() => openTelegram(botAddToGroupUrl(bot, squadId))}
      >
        {t.addBot}
      </Button>
      <p className="text-muted text-xs">{t.rights}</p>
    </div>
  );
}
